import { render, staticRenderFns } from "./CovidBlockedSeatIcon.vue?vue&type=template&id=6f05ef46&scoped=true"
import script from "./CovidBlockedSeatIcon.vue?vue&type=script&lang=js"
export * from "./CovidBlockedSeatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05ef46",
  null
  
)

export default component.exports